// import axios from "axios";
// import { User } from "../components/AddPermission/AddPermission";

// // כתובת הבסיס של ה־API שלך
// const API_URL = "https://localhost:7065/api/User"; // תעדכן לכתובת האמיתית

// class UserService {
//   async getUsers(): Promise<User[]> {
//     const response = await axios.get(API_URL);
//     const data = response.data;

//     return data.map((u: any) => ({
//       id: u.id,
//       fullName: u.fullName,
//       email: u.email,
//       phone: u.phone,
//       passwordHash: u.passwordHash,
//       permissions: u.permissions?.map((p: any) => p.name) ?? [],
//     }));
//   }

//   async updateUser(id: number | undefined, user: User): Promise<User> {
//     // כאן חשוב להתאים את ה־payload למה שה־backend מצפה (UserPostModel)
//     const payload = {
//       fullName: user.fullName,
//       email: user.email,
//       phone: user.phone,
//       passwordHash: user.passwordHash,  
//       // כאן לדוגמה נניח שה־backend רוצה מזהה permissions
//       selectedPermissionIds: [] // למלא אם יש לך mapping ל־Ids
//     };

//     const response = await axios.put(`${API_URL}/${id}`, payload);
//     const u = response.data;
//     return {
//       fullName: u.fullName,
//       email: u.email,
//       phone: u.phone,
//       passwordHash:u.passwordHash,
//       permissions: u.permissions?.map((p: any) => p.name) ?? []
//     };
//   }

//   async addUser  (user: User): Promise<User> {
//     const payload = {
//       fullName: user.fullName,
//       phone: user.phone,
//       email: user.email,
//       passwordHash: user.passwordHash,
//       selectedPermissionIds: user.permissions.map(p => parseInt(p))
//     };
//     const response = await axios.post(API_URL, payload);
//     return response.data;
//   };

  
//    async deleteUser(id: number): Promise<void> {
//     await axios.delete(`${API_URL}/${id}`);
//   }


//   async signIn(email: string, password: string): Promise<User> {
//     const payload = { email, password };
//     const response = await axios.post(`${API_URL}/signin`, payload);
//     const u = response.data;
//     return {
//       id: u.id,
//       fullName: u.fullName,
//       email: u.email,
//       phone: u.phone,
//       passwordHash: u.passwordHash,
//       permissions: u.permissions?.map((p: any) => p.name) ?? [],
//     };
//   }
// }

// export default new UserService();


// import UserService from "../../services/UserService";
// import * as actionType from "../action";
// import { User } from "../../Items/User";

// // --- GET_USERS ---
// export const fetchUsers = () => async (dispatch: any) => {
//   try {
//     const users: User[] = await UserService.getUsers();
//     dispatch({ type: actionType.GET_USERS, payload: users });
//   } catch (error) {
//     console.error("Error fetching users", error);
//   }
// };

// // --- ADD_USER ---
// export const addUser = (user: User) => async (dispatch: any) => {
//   try {
//     const newUser: User = await UserService.addUser(user);
//     dispatch({ type: actionType.ADD_USER, payload: newUser });
//   } catch (error) {
//     console.error("Error adding user", error);
//   }
// };

// // --- EDIT_USER ---
// export const editUser = (id: number, user: User) => async (dispatch: any) => {
//   try {
//     const updatedUser: User = await UserService.updateUser(id, user);
//     dispatch({ type: actionType.EDIT_USER, payload: updatedUser });
//   } catch (error) {
//     console.error("Error editing user", error);
//   }
// };

// // --- DELETE_USER ---
// export const deleteUser = (id: number) => async (dispatch: any) => {
//   try {
//     await UserService.deleteUser(id);
//     dispatch({ type: actionType.DELETE_USER, payload: id });
//   } catch (error) {
//     console.error("Error deleting user", error);
//   }
// };

// // --- SIGN_IN ---
// export const signIn = (email: string, password: string) => async (dispatch: any) => {
//   try {
//     const loggedUser: User = await UserService.signIn(email, password);
//     dispatch({ type: actionType.SIGN_IN, payload: loggedUser });
//   } catch (error) {
//     console.error("Sign in failed", error);
//   }
// };

import axios from "axios";

import store from "../redux/store"; // תוודא שזה הנתיב הנכון ל־store שלך
import * as actionType from "../redux/action";
import { Permission, User, UserPostModel } from "../Items/User";

// כתובת הבסיס של ה־API שלך
const API_URL = "https://app.mamadapp.co.il/api/User"; // תעדכן לכתובת האמיתית

const dispatch = store.dispatch;

// --- GET USERS ---
export const getUsers = async (): Promise<User[]> => {
  const response = await axios.get(API_URL);
  const data = response.data;

  const users: User[] = data.map((u: any) => ({
    id: u.id,
    fullName: u.fullName,
    email: u.email,
    phone: u.phone,
    passwordHash: u.passwordHash,
    permissions: u.permissions?.map((p: any) => ({ id: p.id, name: p.name })) ?? [],

  }));

  dispatch({ type: actionType.GET_USERS, payload: users });
  return users;
};

// --- UPDATE USER ---
export const updateUser = async (
  id: number | undefined,
  user: UserPostModel
): Promise<User> => {
  const payload = {
    fullName: user.fullName,
    email: user.email,
    phone: user.phone,
    passwordHash: user.passwordHash,
    selectedPermissionIds: user.selectedPermissionIds, // להתאים לפי הצורך
  };

  const response = await axios.put(`${API_URL}/${id}`, payload);
  const u = response.data;

  const updatedUser: User = {
    id: u.id,
    fullName: u.fullName,
    email: u.email,
    phone: u.phone,
    passwordHash: u.passwordHash,
    permissions: u.permissions?.map((p: any) => ({ id: p.id, name: p.name })) ?? [],

  };

  dispatch({ type: actionType.EDIT_USER, payload: updatedUser });
  return updatedUser;
};

// --- ADD USER ---
export const addUser = async (user: UserPostModel): Promise<User> => {
  const payload = {
    fullName: user.fullName,
    phone: user.phone,
    email: user.email,
    passwordHash: user.passwordHash,
    selectedPermissionIds: user.selectedPermissionIds.map((p:any) => parseInt(p)),
  };

  const response = await axios.post(API_URL, payload);
  const newUser: User = response.data;

  dispatch({ type: actionType.ADD_USER, payload: newUser });
  return newUser;
};

// --- DELETE USER ---
export const deleteUser = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/${id}`);
  dispatch({ type: actionType.DELETE_USER, payload: id });
};

// --- SIGN IN ---
export const signIn = async (
  email: string,
  password: string
): Promise<User> => {
  console.log("--- פונקציית signIn ב-Service התחילה לרוץ! ---"); // 👈 תוסיפי את זה!
  const payload = { email, password };
  const response = await axios.post(`${API_URL}/signin`, payload);
  const u = response.data;

  const loggedUser: User = {
    id: u.id,
    fullName: u.fullName,
    email: u.email,
    phone: u.phone,
    passwordHash: u.passwordHash,
    permissions: u.permissions?.map((p: any) => p.name) ?? [],
  };
  localStorage.setItem("user", JSON.stringify(loggedUser));

  dispatch({ type: actionType.SIGN_IN, payload: loggedUser });
  return loggedUser;
};

export const getAllPermissions = async (): Promise<Permission[]> => {
  const response = await axios.get(`${API_URL}/permissions`);
  return response.data;
};
